(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kuby-comparison"] && !Shopify.designMode) return;
  try {
    (function(){
 function init(root){
  root.querySelectorAll('[data-kr-compare-controls]').forEach(function(group){
   if(group.dataset.compareReady)return;
   group.dataset.compareReady='true';
   var columns=Array.from(group.querySelectorAll('[data-compare-column]'));
   var grid=group.querySelector('.kr-compare-grid');
   var add=group.querySelector('[data-compare-add]');
   var count=group.querySelector('[data-compare-count]');
   var status=group.querySelector('[data-compare-status]');
   var labels=columns.map(function(column){return column.querySelector('label').textContent;});
   function selectFor(column){return column.querySelector('[data-compare-select]');}
   function active(){return columns.filter(function(column){return !column.hidden;});}
   function nameFor(column){var select=selectFor(column);return select.selectedOptions[0]?select.selectedOptions[0].textContent:'';}
   function sync(){
    var visible=active();var values=visible.map(function(column){return selectFor(column).value;});
    grid.style.setProperty('--compare-count',String(Math.max(1,visible.length)));
    grid.hidden=visible.length===0;
    count.textContent=visible.length+' / '+columns.length;
    add.disabled=visible.length>=columns.length;
    columns.forEach(function(column){
     var select=selectFor(column);var remove=column.querySelector('[data-compare-remove]');
     Array.from(select.options).forEach(function(option){option.disabled=option.value!==select.value&&values.indexOf(option.value)!==-1;});
     column.querySelectorAll('[data-compare-model]').forEach(function(card){card.hidden=column.hidden||card.dataset.compareModel!==select.value;});
     if(!column.hidden)column.querySelector('label').textContent=labels[visible.indexOf(column)];
     remove.setAttribute('aria-label',remove.textContent.replace('×','').trim()+' '+nameFor(column));
    });
   }
   var requested=new URLSearchParams(location.search).get('compare');
   if(requested){
    var requestedCard=Array.from(columns[0].querySelectorAll('[data-compare-model]')).find(function(card){return card.dataset.compareModel===requested||card.querySelector('a').getAttribute('href').split('/').pop()===requested;});
    if(requestedCard){selectFor(columns[0]).value=requestedCard.dataset.compareModel;var used=new Set();active().forEach(function(column){var select=selectFor(column);if(used.has(select.value))select.value=Array.from(select.options).find(function(option){return option.value&&!used.has(option.value);}).value;used.add(select.value);});}
   }
   columns.forEach(function(column){
    selectFor(column).addEventListener('change',function(){sync();status.textContent=nameFor(column)+' · '+count.textContent;});
    var remove=column.querySelector('[data-compare-remove]');remove.hidden=false;
    remove.addEventListener('click',function(){
     var name=nameFor(column);column.hidden=true;selectFor(column).value='';sync();
     status.textContent=remove.textContent.replace('×','').trim()+' '+name+' · '+count.textContent;
     add.focus({preventScroll:true});
    });
   });
   add.hidden=false;
   add.addEventListener('click',function(){
    var column=columns.find(function(item){return item.hidden;});if(!column)return;
    var used=active().map(function(item){return selectFor(item).value;});var select=selectFor(column);
    var next=Array.from(select.options).find(function(option){return option.value&&used.indexOf(option.value)===-1;});if(!next)return;
    select.value=next.value;column.hidden=false;grid.appendChild(column);columns=Array.from(grid.querySelectorAll('[data-compare-column]'));sync();
    status.textContent=nameFor(column)+' · '+count.textContent;select.focus({preventScroll:true});
    var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    column.scrollIntoView({behavior:reduce?'instant':'smooth',block:'nearest',inline:'nearest'});
   });
   sync();
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document);});else init(document);
 document.addEventListener('shopify:section:load',function(event){init(event.target);});
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kuby-design"] && !Shopify.designMode) return;
  try {
    (()=>{const boot=(root=document)=>{const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;if(!reduced&&'IntersectionObserver'in window){const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting){entry.target.animate([{opacity:0,transform:'translateY(18px)'},{opacity:1,transform:'translateY(0)'}],{duration:400,easing:'ease-out'});observer.unobserve(entry.target)}})},{threshold:.12});root.querySelectorAll('.kr-reveal:not([data-seen])').forEach(el=>{el.dataset.seen='true';observer.observe(el)})}root.querySelectorAll('[data-kr-tabs]:not([data-bound])').forEach(group=>{group.dataset.bound='true';const tabs=Array.from(group.querySelectorAll('[role=tab]'));const panels=group.querySelectorAll('[role=tabpanel]');const activate=tab=>{tabs.forEach(t=>{t.setAttribute('aria-selected',String(t===tab));t.tabIndex=t===tab?0:-1});panels.forEach(p=>p.hidden=p.id!==tab.getAttribute('aria-controls'))};tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>activate(tab));tab.addEventListener('keydown',event=>{let next;if(event.key==='ArrowRight')next=(i+1)%tabs.length;if(event.key==='ArrowLeft')next=(i+tabs.length-1)%tabs.length;if(event.key==='Home')next=0;if(event.key==='End')next=tabs.length-1;if(next!==undefined){event.preventDefault();activate(tabs[next]);tabs[next].focus()}})});activate(tabs[0])});root.querySelectorAll('[data-kr-sort]:not([data-bound])').forEach(select=>{select.dataset.bound='true';select.addEventListener('change',()=>select.form.requestSubmit())});root.querySelectorAll('details.kr-accordion:not([data-bound])').forEach(detail=>{detail.dataset.bound='true';detail.addEventListener('toggle',()=>{if(!detail.open)detail.querySelectorAll('video').forEach(v=>v.pause())})});};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>boot());else boot();document.addEventListener('shopify:section:load',e=>boot(e.target));document.addEventListener('keydown',e=>{if(e.key==='Escape')document.querySelectorAll('.kr-header details[open]').forEach(d=>d.open=false)});})();

document.addEventListener('click', event => {
  const button = event.target.closest('[data-kr-industry-video]');
  if (!button) return;
  const frame = document.createElement('iframe');
  frame.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(button.dataset.krIndustryVideo) + '?autoplay=1&rel=0&playsinline=1';
  frame.title = button.closest('.kr-industry-video').querySelector('h2').textContent;
  frame.width = '960'; frame.height = '540';
  frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
  frame.referrerPolicy = 'strict-origin-when-cross-origin';
  frame.allowFullscreen = true;
  button.replaceWith(frame);
  frame.focus();
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kuby-premium"] && !Shopify.designMode) return;
  try {
    (()=>{
 let products={};try{products=JSON.parse(document.getElementById('kr-premium-products')?.textContent||'{}')}catch{}
 const params=new URLSearchParams(location.search);
 function boot(root=document){
  root.querySelectorAll('[data-kr-compare]:not([data-premium-ready])').forEach(group=>{
   group.dataset.premiumReady='true';const selects=[...group.querySelectorAll('[data-compare-select]')];
   const requested=products[params.get('compare')]||params.get('compare');
   if(requested&&[...selects[0].options].some(o=>o.value===requested)){
    selects[0].value=requested;const used=new Set([requested]);selects.slice(1).forEach(select=>{if(used.has(select.value))select.value=[...select.options].find(o=>o.value&&!used.has(o.value)).value;used.add(select.value)});
   }
   function sync(){const values=selects.map(s=>s.value);selects.forEach(select=>{
    [...select.options].forEach(option=>option.disabled=!!option.value&&option.value!==select.value&&values.includes(option.value));
    select.closest('[data-compare-column]').querySelectorAll('[data-compare-model]').forEach(card=>card.hidden=card.dataset.compareModel!==select.value);
   })}
   selects.forEach(select=>select.addEventListener('change',sync));sync();
  });
  root.querySelectorAll('[data-kr-cinema]:not([data-scene-ready])').forEach(hero=>{
   hero.dataset.sceneReady='true';const video=hero.querySelector('video'),group=hero.querySelector('.kr-hero-models');if(!group)return;
   const scenes=[...group.querySelectorAll('[data-hero-scene]')];
   function sync(){const matches=!group.dataset.heroSource||Array.from(video.querySelectorAll('source')).some(source=>source.getAttribute('src')===group.dataset.heroSource);group.hidden=!matches;scenes.forEach(scene=>scene.hidden=!(video.currentTime>=Number(scene.dataset.start)&&video.currentTime<Number(scene.dataset.end)))}
   video.addEventListener('timeupdate',sync);video.addEventListener('loadedmetadata',sync);sync();
  });
  const form=root.querySelector('#KubyContact');
  if(form&&!form.dataset.premiumReady){
   form.dataset.premiumReady='true';const robot=form.querySelector('[data-kr-robot]'),sector=form.querySelector('[data-kr-sector]');
   if(robot&&sector){
    const wanted=products[params.get('product')]||params.get('robot');
    if(wanted&&[...robot.options].some(o=>o.value===wanted))robot.value=wanted;
    if([...sector.options].some(o=>o.value===params.get('sector')))sector.value=params.get('sector');
    const summary=form.querySelector('[data-project-summary]'),name=form.querySelector('[data-project-name]');
    function sync(){const values=[robot,sector].filter(s=>s.value).map(s=>s.selectedOptions[0].textContent);const label=values.join(' · ');if(name.textContent!==label)name.textContent=label;summary.hidden=!values.length;form.querySelectorAll('[data-project-guidance]').forEach(g=>g.hidden=g.dataset.projectGuidance!==((robot.value==='t300'||robot.value==='mp2000')?'transport':robot.value==='bella'||robot.value==='ketty'?'service':'cleaning'))}
    robot.addEventListener('change',sync);sector.addEventListener('change',sync);new MutationObserver(sync).observe(document.documentElement,{attributes:true,attributeFilter:['lang']});sync();
   }
  }
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>boot());else boot();
 document.addEventListener('shopify:section:load',e=>boot(e.target));
})();
  } catch(e) { console.error(e); }
})();

})();
